<template>
  <div class="wrap">
    <myHead nav="6"></myHead>
    <div class="main-content flex-sb">
      <div class="content main">
        <div class="main-head">
          <i class="el-icon-menu"></i>
          关于我们
        </div>
        <div class="section-one">
          <div class="about-info flex-sb">
            <div class="image">
              <img src="@/assets/images/about-us.png">
            </div>
            <div class="info-wrap">
              <div class="info-title"><span class="devi"></span>公司简介</div>
              <div class="text">
                {{company.company_intro}}
              </div>
            </div>
          </div>
          <div class="contact-info">
            <p>地址：{{company.company_address}}</p>
            <p>电话：{{company.company_tel}}</p>
            <p>邮箱：{{company.company_email}}</p>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<!-- 法律法规 -->
<script>
  import Vue from 'vue';
  import myHead from '../../components/myHead/myhead';
  import myFoot from '../../components/myFoot/myfoot';
  import common from '../../assets/js/utils/common';
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";
  export default {
    name: "regulation",
    data() {
      return {
        company:{}
      }
    },
    components: {
      myHead,
      myFoot
    },
    mounted() {
      this.init()
    },
    computed: {

    },
    created() {},
    methods: {
      ...mapActions({
        getConfigCompany: "index/getConfigCompany",
      }),
      init(){
        this.getConfigCompany({
          data:{},
          success:(res) => {
            if(res.code == 1){
              this.company = res.data
            }
          },
        })
      }
    }
  }
</script>

<style scoped>
  .main-content {
    position: relative;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto 0;
    width: 1200px;
  }

  .main-content .main {
    width: 1200px;
    background: #fff;
  }

 .main-head {
     text-align: left;
     position: relative;
     padding: 0 20px;
     font-size: 20px;
     font-weight: 700;
     background: #f5fafc;
     color: #0080FF;
     height: 72px;
     line-height: 72px;
   }
 
   .main-head::before {
    /* content: '';
     position: relative;
     top: 3px;
     display: inline-block;
     width: 20px;
     height: 20px; */
     /* background: #4370ff; */
     /* background: url(../../assets/images/title-before.png); */
   }
  .main-content .section-one {
    padding: 16px 20px;
  }

  .main-content .section-one .about-info {
    padding: 0 10px;
  }

  .main-content .section-one .about-info .image {
    width: 355px;
    height: 200px;
    display: inline-block;
  }

  .main-content .section-one .about-info .image img {
    max-width: 100%;
    max-height: 100%;
  }

  .main-content .section-one .about-info .info-wrap {
    display: inline-block;
    width: 775px;
    vertical-align: top;
    padding: 25px;
  }

  .main-content .section-one .about-info .info-wrap .info-title {
    display: inline-flex;
    line-height: 40px;
    font-size: 22px;
    position: relative;
    align-items: center;
  }
  .main-content .section-one .about-info .info-wrap .info-title .devi{
    background-color: #0080FF;
    width: 6px;
    height: 20px;
    display: inline-block;
    margin-right: 8px;
  }

  .main-content .section-one .about-info .info-wrap .text {
    line-height: 26px;
  }

  .main-content .section-one .contact-info {
    margin-top: 20px;
    font-size: 16px;
    color: #747474;
    line-height: 30px;
    padding: 0 10px;
  }
  .main-content .section-one .contact-info p{
    display: block;
    padding: 10px 0;
  }
</style>
